import { parentApi } from "./message-proxy";

const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;

export function relayUrlChangesToHost() {
  const handleLocationChange = ({ replace }: { replace: boolean }) => {
    const url = new URL(window.location.href);
    parentApi.relayUrlToHost({
      pathname: url.pathname,
      hash: url.hash,
      search: url.search,
      replace,
    });
  };

  history.pushState = function (...args) {
    originalPushState.apply(this, args);
    handleLocationChange({ replace: false });
  };

  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    handleLocationChange({ replace: true });
  };

  window.addEventListener("popstate", function () {
    handleLocationChange({ replace: true });
  });

  window.addEventListener("hashchange", function () {
    handleLocationChange({ replace: false });
  });
}
